var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRotation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.30406 2.63656C7.85606 2.17389 10.3795 3.74336 11.0639 6.2976C11.785 8.98857 10.1917 11.7536 7.50538 12.4734C4.81901 13.1932 2.05675 11.5952 1.33571 8.90426C0.999789 7.6506 1.16616 6.38086 1.71136 5.30935",
    stroke: "#202840",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4086 4.20298L4.70382 2.70478L6.20203 1",
    stroke: "#202840",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRotation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Rotation.0fa8ec73dda68abc9429d191f8617f6b.svg";